<nav class="navbar navbar-expand-lg nav-neo">
    <div class="container-fluid nav-neo__wrap">

        <button class="navbar-toggler nav-neo__toggler" type="button" data-bs-toggle="collapse"
            data-bs-target="#neoNavbar" aria-controls="neoNavbar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="nav-neo__toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="neoNavbar">
            <ul class="navbar-nav align-items-lg-center nav-neo__menu">
                <li class="nav-item">
                    <a class="nav-link nav-neo__link" routerLink="/">Home</a>
                </li>
                
                @for (docType of documentTypeService.documentTypes; track docType.id) {
                    @if (docType.add_to_header) {
                        @if(docType.children!.length > 0 && docType.children!.length && docType.children!.length < 5){
                            <li class="nav-item dropdown">
                                <span class="nav-link nav-neo__link d-flex">

                                    @if (docType.slug.startsWith('stateApp_')) {
                                        @if (hasState()) {
                                            <a [routerLink]="['/', stateCode(), ...docType.slug.replace('stateApp_', '').split('_')]">{{ docType.name }}</a>
                                        } @else {
                                            <a class="disabled" style="cursor: not-allowed; opacity: 0.6;" data-bs-toggle="tooltip" title="Please select a state first">{{ docType.name }}</a>
                                        }
                                    } @else {
                                        <a [routerLink]="[docType.slug]">{{ docType.name }}</a>
                                    }
                                    <a class="nav-link dropdown-toggle dropdown-toggle-split" href="#" data-bs-toggle="dropdown"
                                        aria-expanded="false"> </a>
                                    <ul class="dropdown-menu nav-neo__dropdown" aria-labelledby="neoDropdown">
                                        @for (child of docType.children; track child.id) {
                                        <li>
                                            @if (child.slug.startsWith('stateApp_')) {
                                                @if (hasState()) {
                                                    <a class="dropdown-item" [routerLink]="['/', stateCode(), ...child.slug.replace('stateApp_', '').split('_')]">{{ child.name }}</a>
                                                } @else {
                                                    <a class="dropdown-item disabled" style="cursor: not-allowed; opacity: 0.6;" data-bs-toggle="tooltip" title="Please select a state first">{{ child.name }}</a>
                                                }
                                            } @else {
                                                <a class="dropdown-item" [routerLink]="['/', ...child.slug.split('_')]">{{ child.name }}</a>
                                            }
                                        </li>
                                        }
                                    </ul>
                                </span>
                            </li>
                        } @else {
                            <li class="nav-item ">
                                @if (docType.slug.startsWith('stateApp_')) {
                                    @if (hasState()) {
                                        <a class="nav-link nav-neo__link" [routerLink]="['/', stateCode(), ...docType.slug.replace('stateApp_', '').split('_')]">
                                        {{docType.add_to_header}} {{ docType.name }}
                                        </a>
                                    } @else {
                                        <a class="nav-link nav-neo__link disabled" style="cursor: not-allowed; opacity: 0.6;" data-bs-toggle="tooltip" title="Please select a state first">
                                            {{ docType.name }}
                                        </a>
                                    }
                                } @else {
                                    <a class="nav-link nav-neo__link" [routerLink]="['/', docType.slug]">
                                    {{docType.add_to_header}} {{ docType.name }}
                                    </a>
                                }
                            </li>
                        }
                    }

                }

                <li class="nav-item">
                    <a class="nav-link nav-neo__link" routerLink="/contact" routerLinkActive="active">Contact Us</a>
                </li>
            </ul>
            <div class="ms-lg-auto d-flex align-items-center gap-3 mt-3 mt-lg-0">
                @if (hasState()) {
                    <a class="btn btn-sm btn-outline-light nav-neo__btn-change" routerLink="/select-state">
                        Change State
                    </a>
                }
                
                <a routerLink="/cart" class="nav-cart-btn" aria-label="View Cart">
                    <span class="material-symbols-outlined nav-cart-icon">shopping_cart</span>
                    @if (orderProcessing.cartItemCount() > 0) {
                        <span class="cart-badge">
                            {{ orderProcessing.cartItemCount() }}
                        </span>
                    }
                </a>
            </div>
        </div>
    </div>
</nav>